import { sdkContextStatus } from "src/context/SDKContext"
import { useQuery, useQueryClient } from "react-query"
import axios from "src/shared/axios"

const QUERY_KEY = "onboarding"

export type Onboarding = {
  onboardingId?: number
  data: unknown
  userId: number
}

export function useOnboarding() {
  const queryClient = useQueryClient()

  const getOnboarding = () => {
    const { data } = useQuery<Onboarding[]>({
      queryKey: [QUERY_KEY],
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      queryFn: async () => {
        const meetingClient = await sdkContextStatus
        const url = new URL(meetingClient?.envConfig.ONBOARDING)
        url.searchParams.append(
          "host",
          meetingClient?.envConfig.DOMAIN_HOSTNAME
        )
        const response = await axios.get(url.toString(), {
          withCredentials: true
        })
        return response.data
      }
    })
    return data
  }

  const getOnboardingPromise = () => {
    const data = queryClient.fetchQuery<Onboarding[]>({
      queryKey: [QUERY_KEY],
      queryFn: async () => {
        const meetingClient = await sdkContextStatus
        const url = new URL(meetingClient?.envConfig.ONBOARDING)
        url.searchParams.append(
          "host",
          meetingClient?.envConfig.DOMAIN_HOSTNAME
        )
        const response = await axios.get(url.toString(), {
          withCredentials: true
        })
        return response.data
      }
    })
    return data
  }

  const putOnboarding = async (onboarding: Onboarding) => {
    const meetingClient = await sdkContextStatus
    const url = new URL(meetingClient?.envConfig.ONBOARDING)
    url.searchParams.append("host", meetingClient?.envConfig.DOMAIN_HOSTNAME)
    try {
      const response = axios.put(url.toString(), onboarding, {
        withCredentials: true
      })
      return response.then(() => queryClient.invalidateQueries(QUERY_KEY))
    } catch (err) {
      console.error(err)
      throw err
    }
  }

  const postOnboarding = async (onboarding: Onboarding) => {
    const meetingClient = await sdkContextStatus
    const url = new URL(meetingClient?.envConfig.ONBOARDING)
    url.searchParams.append("host", meetingClient?.envConfig.DOMAIN_HOSTNAME)
    try {
      const response = axios.post(url.toString(), onboarding, {
        withCredentials: true
      })
      return response.then(() => queryClient.invalidateQueries(QUERY_KEY))
    } catch (err) {
      console.error(err)
      throw err
    }
  }

  return {
    getOnboarding,
    getOnboardingPromise,
    putOnboarding,
    postOnboarding
  }
}

export type LearnMachineOnboardingData = {
  selectedBoard: string
  selectedCourse: string
  selectedLevel: string
}

export const constructTagFilterForLM = (
  onboardings: Onboarding[] | undefined
) => {
  const onboarding = onboardings?.at(0)
  if (!onboarding) return "--none--"
  const data = onboarding.data as LearnMachineOnboardingData
  return `${data.selectedCourse}-${data.selectedBoard}`
}
